<template>
  <div class="modal fade" id="empresaModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="isEditing && empresa?.nombre">Editar: {{ empresa.nombre }}</span>
            <span v-else>Agregar Empresa</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">

            <div class="form-group">
              <label>Nombre</label>
              <input v-model="form.nombre" type="text" class="form-control text-uppercase"
                :class="{ 'is-invalid': errors.nombre }" placeholder="Ej: Inversiones Kurda C.A." :disabled="isEditing" />
              <div class="invalid-feedback">{{ errors.nombre }}</div>
            </div>

            <div class="form-group">
              <label>RIF</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <select v-model="form.rif_prefijo" class="form-control"
                    style="border-top-right-radius: 0; border-bottom-right-radius: 0;" :disabled="isEditing">
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="G">G</option>
                    <option value="P">P</option>
                  </select>
                </div>
                <input v-model="form.rif_numero" type="text" class="form-control" :class="{ 'is-invalid': errors.rif }"
                  placeholder="123456789" maxlength="9" @input="onlyNumbersRif" :disabled="isEditing" />
                <div v-if="errors.rif" class="invalid-feedback">{{ errors.rif }}</div>
              </div>
              <small class="text-muted">Seleccione el prefijo y escriba solo los números.</small>
            </div>

            <div class="form-group">
              <label>Dirección</label>
              <input v-model="form.direccion" type="text" class="form-control text-uppercase"
                :class="{ 'is-invalid': errors.direccion }" placeholder="Ej: Av. Principal, Puerto La Cruz" />
              <div class="invalid-feedback">{{ errors.direccion }}</div>
            </div>

            <div class="form-group">
              <label>Teléfono de Contacto</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <select v-model="form.tel_prefijo" class="form-control"
                    style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                    <option value="0412">0412</option>
                    <option value="0422">0422</option>
                    <option value="0414">0414</option>
                    <option value="0424">0424</option>
                    <option value="0416">0416</option>
                    <option value="0426">0426</option>
                  </select>
                </div>
                <input v-model="form.tel_numero" type="text" class="form-control"
                  :class="{ 'is-invalid': errors.telefono }" placeholder="1234567" maxlength="7"
                  @input="onlyNumbersTel" />
                <div v-if="errors.telefono" class="invalid-feedback">{{ errors.telefono }}</div>
              </div>
              <small class="text-muted">Seleccione el código y escriba los 7 números restantes.</small>
            </div>

            <div class="form-group">
              <label>Email</label>
              <input v-model="form.email" type="email" class="form-control" :class="{ 'is-invalid': errors.email }"
                placeholder="Ej: contacto@empresa.com" />
              <div class="invalid-feedback">{{ errors.email }}</div>
            </div>

            <div class="modal-footer px-0 pb-0">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
              <button type="submit" class="btn btn-primary">
                {{ isEditing ? "Actualizar" : "Guardar" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
  props: ["empresa"],
  data() {
    return {
      form: { nombre: "", rif_prefijo: "J", rif_numero: "", tel_prefijo: "0412", tel_numero: "", direccion: "", email: "" },
      errors: {} // Para almacenar mensajes de error por campo
    };
  },
  computed: {
    // Solo estamos editando si el objeto 'empresa' existe Y tiene un 'id'
    isEditing() {
      return !!(this.empresa && (this.empresa.id || this.empresa.id_empresa));
    },
  },
  watch: {
    empresa: {
      immediate: true,
      handler(newEmpresa) {
        this.errors = {}; // Limpiar errores previos siempre
        if (newEmpresa && (newEmpresa.id || newEmpresa.id_empresa)) {
          const rif = newEmpresa.rif || "";
          const tel = (newEmpresa.contacto || "").replace(/\s+/g, '');
          this.form = {
            nombre: newEmpresa.nombre || "",
            direccion: newEmpresa.direccion || "",
            email: newEmpresa.email || "",
            rif_prefijo: rif.charAt(0) || "J",
            rif_numero: rif.slice(1) || "",
            tel_prefijo: tel.slice(0, 4) || "0412",
            tel_numero: tel.slice(4) || ""
          };
        } else {
          this.form = this.getDefaultForm();
        }
      }
    }
  },
  methods: {
    getDefaultForm() {
      return { nombre: "", rif_prefijo: "J", rif_numero: "", tel_prefijo: "0412", tel_numero: "", direccion: "", email: "" };
    },
    onlyNumbersRif(event) {
      this.form.rif_numero = event.target.value.replace(/\D/g, "");
    },
    onlyNumbersTel(event) {
      this.form.tel_numero = event.target.value.replace(/\D/g, "");
    },

    async submitForm() {
      this.errors = {};

      const nombreVal = (this.form.nombre || "").trim();
      const direccionVal = (this.form.direccion || "").trim();

      if (nombreVal.length < 3) {
        this.errors.nombre = "El nombre es obligatorio.";
      }
      if ((this.form.rif_numero || "").length < 8) {
        this.errors.rif = "El RIF debe tener entre 8 y 9 dígitos.";
      }
      if ((this.form.tel_numero || "").length !== 7) {
        this.errors.telefono = "El número debe tener exactamente 7 dígitos.";
      }
      if (direccionVal.length < 10) {
        this.errors.direccion = "La dirección debe ser más detallada.";
      }

      if (Object.keys(this.errors).length > 0) {
        alert.toast({ title: 'Revisa los campos', icon: 'warning' });
        return;
      }

      try {
        loading.show('Guardando...');

        const payload = {
          nombre: nombreVal.toUpperCase(),
          rif: (this.form.rif_prefijo + this.form.rif_numero).toUpperCase(),
          contacto: this.form.tel_prefijo + this.form.tel_numero,
          direccion: direccionVal.toUpperCase(),
          email: this.form.email ? this.form.email.toLowerCase().trim() : null
        };
        console.log("Payload a enviar:", payload);
        // Usamos la propiedad computada ya blindada
        if (this.isEditing && this.empresa?.id) {
          await api.put(`/empresa/${this.empresa.id}`, payload);
        } else {
          await api.post("/empresa", payload);
        }

        loading.hide();
        alert.toast({ title: 'Configuración guardada', icon: 'success' });

        $("#empresaModal").modal("hide");
        this.$emit("success");
      } catch (error) {
        loading.hide();
        // Extraemos el mensaje de error de forma segura
        const mensajeServidor = error.response?.data?.message || 'Error desconocido';
        alert.toast({ title: 'No se pudo guardar: ' + mensajeServidor, icon: 'warning' });

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
        } else {
          alert.toast({ title: 'Error de servidor', icon: 'error' });
        }
      }
    },
  },
};
</script>